import {get,post} from '../http';

// method, url, data = null
// 保存当前浏览页面
export function save_visit(obj) {
    return post('/api.php/index/save_visit', obj)
}
// 保存当前浏览页面
export function get_visit(obj) {
    return get('/api.php/index/get_visit', obj)
}

//党史百年
export function index(obj) {
    return get('/api.php/index/index', obj)
}
//时间线
export function timeline(obj) {
    return get('/api.php/index/timeline', obj)
}
//详情
export function detail(obj) {
    return get('/api.php/index/detail', obj)
}

